import { useState, useEffect, useCallback, useRef } from "react"

import Grid from '@material-ui/core/Grid'
import { Card, CardContent } from "@material-ui/core"
import Chip from '@material-ui/core/Chip'
import AddIcon from '@material-ui/icons/AddOutlined'
import LoopOutlinedIcon from '@material-ui/icons/LoopOutlined';
import CircularProgress from '@material-ui/core/CircularProgress'

import Dialog from "@base/Dialog"
import Toast from '@base/Toast'
import SelectOption from '@base/Inputs/Select/Select'
import ButtonPrimary from '@base/Button'

import EmpresaService from "@services/EmpresaService"

import useEmpresas from '@hooks/enums/useEmpresas';

export const AtribuirEmpresaDialog = (props) => {
	const toastRef = useRef(null);

	const [empresaSelecionada, setEmpresaSelecionada] = useState("");
	const [loading, setLoading] = useState(true);

	const listagemTodasEmpresas = useEmpresas();
	const [listagemEmpresasDoColaborador, setListagemEmpresasDoColaborador] = useState([]);
	
	const listagemEmpresas = listagemTodasEmpresas.data.filter(obj => !listagemEmpresasDoColaborador.find(rm => rm.id === obj.value));

	const removerEmpresa = () => {
		EmpresaService.removerEmpresaColaborador(props.id)
      .then(() => {
				setEmpresaSelecionada("");
				carregarDados();
				toastRef.current.show("success","Empresa de Colaborador foi removida com sucesso!");
			})
      .catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Remover Empresa de Colaborador"));
	}

	const adicionarEmpresa = (empresa) => {
		if (empresa === "") {
				toastRef.current.show("warning", "É necessário selecionar uma Empresa para o Colaborador.");
		} else {
			EmpresaService.adicionarEmpresaColaborador({ id : props.id, empresa : empresa }).then(() => {
				setEmpresaSelecionada("");
				carregarDados();
				toastRef.current.show("success","Empresa de Colaborador foi adicionada com sucesso!");
			}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Adicionar Empresa de Colaborador"));
		}
	}

	const limparFormulario = () => {
		setEmpresaSelecionada("");
		setListagemEmpresasDoColaborador([]);
	}

	const fecharDialog = () => {
		limparFormulario();
		props.aoFechar();
	}

	const carregarDados = useCallback(() => {
		setLoading(true);

		EmpresaService.listarEmpresaColaborador(props.id).then(resposta => {
			setListagemEmpresasDoColaborador(resposta.data);
		}).catch(error => {
			toastRef.current?.show("error", "Ocorreu um Problema ao recuperar as Empresas associadas a este Colaborador.");
		}).finally(() => setLoading(false));

	}, [props.id]);

	useEffect(() => carregarDados(), [carregarDados]);

	return (
		<>
			<Toast ref={toastRef} />
			<Dialog
				maxWidth={"sm"}
				fullWidth={true}
				closeDialog={fecharDialog}
				openDialog={props.aberto}
				title="Associar Empresa"
      >
				{listagemEmpresasDoColaborador && listagemEmpresasDoColaborador.length > 0 ?
          <Card>
            <CardContent style={{ fontSize: 12, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>Empresas Associadas</CardContent>
            <CardContent>
              {listagemEmpresasDoColaborador.map(elemento =>
                <Grid container spacing={2}>
                  <Grid item sm={12}>
                    <Chip label={elemento.nome} onDelete={() => removerEmpresa()} />
                  </Grid>
                </Grid>
              )}
            </CardContent>
          </Card>
        : <></> }

		{listagemEmpresas && listagemEmpresas.length > 0 ?
          <Grid container spacing={2}>
            <Grid item sm={9}>
              <SelectOption
                label='Empresa'
                value={empresaSelecionada}
                name='empresaSelecionada'
                onChange={(e) => setEmpresaSelecionada(e.target.value)}
                options={listagemEmpresas} />
            </Grid>
            <Grid item sm={3}>
              <ButtonPrimary style={{marginTop:33}}
                onClick={() => adicionarEmpresa(empresaSelecionada)}
                name={listagemEmpresasDoColaborador.length > 0 ? "Trocar" : "Adicionar" }
                startIcon={loading ? <CircularProgress size={16} /> : listagemEmpresasDoColaborador.length > 0 ? <LoopOutlinedIcon/> : <AddIcon />}
                disabled={loading}
              />
            </Grid>
          </Grid>
        : <></> }
			</Dialog>
		</>
	);
}

export default AtribuirEmpresaDialog;
